
const LOGO_URL = 'https://goairshop.com/cdn/shop/t/148/assets/'
const BLACK_OWNED_AT_AIRSHOP = 'black_owned_at_airshop'
const BLACK_OWNED_URL = `https://cdn.shopify.com/s/files/1/0569/9957/5718/files/${BLACK_OWNED_AT_AIRSHOP}.png?v=1727372730`
const PARABENS_URL = 'https://goairshop.com/cdn/shop/t/148/assets/without_parabens.png'
const WITHOUT_PARABENS = 'without_parabensmatte_finish'

const generateImageUrlFromHighlightUtil = (highlight) => {
  const imgName = highlight
    .toLowerCase()
    .replace(/:|\/|, | & | |-/g, '_')
    .replace(/ /g, '_')
    .replace(/_+/g, '_') // Replace consecutive underscores with a single underscore
    .concat('.png')

  if (imgName === WITHOUT_PARABENS.concat('.png')) {
    return PARABENS_URL
  }

  if (imgName === BLACK_OWNED_AT_AIRSHOP.concat('.png')) {
    return BLACK_OWNED_URL
  }

  return LOGO_URL + imgName
}

export default generateImageUrlFromHighlightUtil
